import { render, staticRenderFns } from "./PV.vue?vue&type=template&id=60955edc&scoped=true"
import script from "./PV.vue?vue&type=script&lang=js"
export * from "./PV.vue?vue&type=script&lang=js"
import style0 from "./PV.vue?vue&type=style&index=0&id=60955edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60955edc",
  null
  
)

export default component.exports